<script lang="ts">
  import WrapField from "./WrapField.svelte";
  import { getContext, onMount } from "svelte";
  import Composer from "app/components/editor/Composer.svelte";
  import type { createFormStore } from "../store";
  import type { YdocStore } from "app/components/editor/ydoc";
  import type { User } from "$stores/user";

  export let ydoc: YdocStore;
  export let user: User;
  export let name: string;
  export let label: string = "";
  export let validationRules: Record<string, any> = {};
  export let placeholder: string = "Add thread body...";
  export let advancedBlocks: boolean = false;
  export let wrapperClassname = "";

  const formStore: ReturnType<typeof createFormStore> | undefined = getContext("form");
  let ref: HTMLDivElement;
  let value = $formStore?.values[name] || "";
  // need initial value set once, separate from form state to initialise Editor
  let content = value?.json;

  function onUpdate(update: any) {
    if (formStore) {
      formStore.setField(name, {
        json: update.json,
        text: update.text,
        empty: update.empty,
      });
    }
  }

  function onSubmit() {
    if (formStore) {
      $formStore?.submitForm();
    }
  }

  onMount(() => {
    if (formStore) {
      formStore.addRef(name, ref);
    }
  });
</script>

<WrapField {label} {name} {wrapperClassname} {validationRules}>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    bind:this={ref}
    class="h-full rounded-[10px]"
    on:keydown={(k) => {
      if (k.key === "Tab") {
        // Without this, since this is a form field, the browser will switch focus to the next form field.
        // Disabling this allows the use of Tab key for special actions in the text editor (indenting bullet points).
        // Just noting here that this is potentially problematic for people using screen readers who want to tab to
        // the next field.
        k.preventDefault();
        k.stopPropagation();
      }
    }}
  >
    <Composer
      editable
      {ydoc}
      {content}
      {placeholder}
      {advancedBlocks}
      on:update={(e) => onUpdate(e.detail)}
      on:submit={onSubmit}
      highlightColor=""
      {user}
    />
  </div>
</WrapField>
